import styled from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	width: 260px;
	border-radius: 10px;
	overflow: hidden;
	background: rgba(255, 255, 255, 0.9);
`;

const StyledItem = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	width: 100%;
	height: 62px;
	padding: 0 20px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #000000;

		img {
			filter: invert(0);
		}

		${TextLabel} {
			color: #ffffff;
		}
	}

	img {
		width: 20px;
		height: 20px;
		object-fit: contain;
		filter: invert(100%);
		transition: filter 0.3s ease;
	}

	${TextLabel} {
		font-size: 14px;
		color: #000000;
		transition: color 0.3s ease;
	}
`;

export { StyledContainer, StyledItem };
